import { useMemo } from 'react';
import { useTheme } from 'hooks/useTheme';

/**
 * Resolves the 10 `viz-cat-*` categorical chart-color slots for the active
 * UI theme. `dark`/`light` map to each slot's `-primary`/`-secondary` token
 * respectively - these names match the `chartTheme` shape already persisted
 * on dashlets/dashboards (`fe_extra_info.dashletStyleConfig.chartTheme`,
 * `style_settings.chartTheme`) and read by the chart managers, not the app's
 * light/high-contrast/qa UI themes.
 */
export const useVizCatColors = () => {
  const { getSemanticColor } = useTheme();

  return useMemo(
    () => [
      {
        dark: getSemanticColor('viz-cat-1-primary'),
        light: getSemanticColor('viz-cat-1-secondary'),
      },
      {
        dark: getSemanticColor('viz-cat-2-primary'),
        light: getSemanticColor('viz-cat-2-secondary'),
      },
      {
        dark: getSemanticColor('viz-cat-3-primary'),
        light: getSemanticColor('viz-cat-3-secondary'),
      },
      {
        dark: getSemanticColor('viz-cat-4-primary'),
        light: getSemanticColor('viz-cat-4-secondary'),
      },
      {
        dark: getSemanticColor('viz-cat-5-primary'),
        light: getSemanticColor('viz-cat-5-secondary'),
      },
      {
        dark: getSemanticColor('viz-cat-6-primary'),
        light: getSemanticColor('viz-cat-6-secondary'),
      },
      {
        dark: getSemanticColor('viz-cat-7-primary'),
        light: getSemanticColor('viz-cat-7-secondary'),
      },
      {
        dark: getSemanticColor('viz-cat-8-primary'),
        light: getSemanticColor('viz-cat-8-secondary'),
      },
      {
        dark: getSemanticColor('viz-cat-9-primary'),
        light: getSemanticColor('viz-cat-9-secondary'),
      },
      {
        dark: getSemanticColor('viz-cat-10-primary'),
        light: getSemanticColor('viz-cat-10-secondary'),
      },
    ],
    [getSemanticColor]
  );
};
